module.exports = __webpack_public_path__ + "img/3-1.3b3d465.png";